import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#575655"
        d="M298.043 46.028c3.481-8.392-.8-14.893-6.311-7.65l-2.253 3.151c-11.245 16.706-17.25 31.087-29.234 45.999-8.865 20.223-16.153 41.191-22.561 62.275-9.643 32.592-21.52 67.253-21.52 99.844 0 5.19 1.002 10.151 2.815 14.702 10.598 10.613 19.255 19.986 36.032 19.986 21.966 0 31.175-14.946 31.175-36.913 0-26.27-3.128-50.632-3.634-77.268-.763-26.565 2.481-53.737 6.12-80.137 2.542-17.53 3.623-27.208 9.371-43.989z"
        data-original="#ec806b"
      ></path>
      <path
        d="M292.473 90.833c-3.631 26.404-4.877 53.282-4.118 79.848.515 26.634 7.478 52.7 7.478 78.968 0 21.96-17.869 39.829-39.829 39.829-16.785 0-31.173-10.418-37.025-25.13 2.33.447 4.728.664 7.18.664 21.974 0 39.843-17.883 39.843-39.843 0-26.268-6.977-52.334-7.478-78.968-.555-19.495-.041-39.152 1.721-58.674 8.074-18.438 17.462-36.239 28.707-52.943l2.262-3.157c5.5-7.234 16.447-.853 12.965 7.546-5.745 16.772-9.159 34.33-11.706 51.86z"
        data-original="#e0685f"
      ></path>
      <path
        fill="#ffdcd0"
        d="M500.81 378.787l-482.61-4.74L0 328.617v-97.98a4 4 0 014-4h13.05c8.59 0 15.55 7.2 14.98 15.76a61.33 61.33 0 00-.13 4.08c0 33.21 26.78 60.23 59.7 60.23s59.71-27.02 59.71-60.23c0-4.308-.46-8.526-1.319-12.584-.79-3.733 2.003-7.256 5.819-7.256h27.6c3.84 0 6.67 3.56 5.81 7.3a69.73 69.73 0 00-1.75 17.98c1.17 36.79 31.25 66.63 68.05 67.54 39.3.97 71.59-30.72 71.59-69.82 0-5.37-.61-10.6-1.76-15.62-.87-3.77 1.92-7.38 5.79-7.38h24.01c3.816 0 6.609 3.524 5.818 7.257a60.765 60.765 0 00-1.309 12.583c0 33.21 26.78 60.23 59.7 60.23s59.7-27.02 59.7-60.23c0-1.07 1.748-2.213 1.688-3.273-.47-9.05 3.632-12.047 12.692-12.047h11.06z"
        data-original="#ffdcd0"
      ></path>
      <path
        fill="#ffb5a5"
        d="M505.324 491.207c0 3.31-2.771 6-6.181 6l-42.929 5.44H6.181c-3.41 0-6.181-2.69-6.181-6v-71.169l18.203-51.43 477.314 13.22z"
        data-original="#ffb5a5"
      ></path>
      <path
        fill="#ffc7b6"
        d="M512 230.637v97.98l-11.19 50.17h-21.78v-137.83c.75-7.99 7.48-14.32 15.76-14.32H508a4 4 0 014 4z"
        data-original="#ffc7b6"
      ></path>
      <path
        fill="#f9a791"
        d="M500.806 378.789h-21.772v94.743c0 16.08-13.429 29.116-29.995 29.116h56.779c3.414 0 6.181-2.686 6.181-6v-71.169l-11.717-44.345z"
        data-original="#f9a791"
      ></path>
      <path
        fill="#fe93bb"
        d="M426.663 357.213c-42.669 0-42.669-28.597-85.337-28.597-42.667 0-42.667 28.597-85.333 28.597-42.665 0-42.665-28.597-85.33-28.597-42.666 0-42.666 28.597-85.332 28.597-42.665 0-42.665-28.597-85.331-28.597v30.73l3.808 15-3.808 15v36.135c42.665 0 42.665 28.597 85.331 28.597s42.666-28.597 85.332-28.597c42.665 0 42.665 28.597 85.33 28.597 42.666 0 42.666-28.597 85.333-28.597 42.668 0 42.668 28.597 85.337 28.597 34.012 0 40.913-18.17 63.924-25.543V331.67c-23.011 7.373-29.912 25.543-63.924 25.543z"
        data-original="#fe93bb"
      ></path>
      <path
        fill="#fe76a8"
        d="M512 328.618v30.729l-3.575 16.948L512 389.347v36.131c-15.051 0-24.786 3.56-32.966 8.17v-96.86c8.18-4.61 17.915-8.17 32.966-8.17z"
        data-original="#fe76a8"
      ></path>
      <g fill="#f6f0f7">
        <ellipse
          cx="256"
          cy="405.646"
          data-original="#f6f0f7"
          rx="20.604"
          ry="20"
        ></ellipse>
        <ellipse
          cx="85.331"
          cy="405.646"
          data-original="#f6f0f7"
          rx="20.604"
          ry="20"
        ></ellipse>
        <ellipse
          cx="426.663"
          cy="405.646"
          data-original="#f6f0f7"
          rx="20.604"
          ry="20"
        ></ellipse>
        <ellipse
          cx="170.663"
          cy="374.049"
          data-original="#f6f0f7"
          rx="15.453"
          ry="15"
        ></ellipse>
        <ellipse
          cx="341.326"
          cy="374.049"
          data-original="#f6f0f7"
          rx="15.453"
          ry="15"
        ></ellipse>
      </g>
      <path
        fill="#ece6ed"
        d="M512 359.347v30c-8.53 0-15.453-6.71-15.453-15 0-8.28 6.923-15 15.453-15z"
        data-original="#ece6ed"
      ></path>
      <path
        fill="#f6f0f7"
        d="M15.453 374.347c0 8.29-6.923 15-15.453 15v-30c8.53 0 15.453 6.72 15.453 15z"
        data-original="#f6f0f7"
      ></path>
      <path
        fill="#575655"
        d="M449.171 97.604c2.569-6.195-.591-10.993-4.659-5.647l-1.663 2.326c-8.3 12.331-12.733 22.946-21.579 33.954-6.544 14.927-11.923 30.405-16.653 45.968-7.118 24.057-15.885 49.643-15.885 73.7 0 3.831.739 7.493 2.078 10.852 7.823 7.834 14.213 14.753 26.597 14.753 16.214 0 23.012-11.032 23.012-27.247 0-19.391-2.309-37.374-2.682-57.035-.563-19.609 1.831-39.666 4.518-59.153 1.876-12.94 2.674-20.084 6.916-32.471z"
        data-original="#ec806b"
      ></path>
      <path
        d="M445.06 130.677c-2.68 19.49-3.6 39.33-3.04 58.94.38 19.66 5.52 38.9 5.52 58.29 0 16.21-13.19 29.4-29.4 29.4-12.39 0-23.01-7.69-27.33-18.55 1.72.33 3.49.49 5.3.49 16.22 0 29.41-13.2 29.41-29.41 0-19.39-5.15-38.63-5.52-58.29-.41-14.39-.03-28.9 1.27-43.31 5.96-13.61 12.89-26.75 21.19-39.08l1.67-2.33c4.06-5.34 12.14-.63 9.57 5.57-4.24 12.38-6.76 25.34-8.64 38.28z"
        data-original="#e0685f"
      ></path>
      <path
        fill="#575655"
        d="M121.413 97.604c2.569-6.195-.591-10.993-4.659-5.647l-1.663 2.326c-8.3 12.331-12.733 22.946-21.579 33.954-6.544 14.927-11.923 30.405-16.653 45.968-7.118 24.057-15.885 49.643-15.885 73.7 0 3.831.739 7.493 2.078 10.852 7.823 7.834 14.213 14.753 26.597 14.753 16.214 0 23.012-11.032 23.012-27.247 0-19.391-2.309-37.374-2.682-57.035-.563-19.609 1.831-39.666 4.518-59.153 1.875-12.94 2.673-20.084 6.916-32.471z"
        data-original="#ec806b"
      ></path>
      <path
        d="M117.302 130.677c-2.68 19.49-3.6 39.33-3.04 58.94.38 19.66 5.52 38.9 5.52 58.29 0 16.21-13.19 29.4-29.4 29.4-12.39 0-23.01-7.69-27.33-18.55 1.72.33 3.49.49 5.3.49 16.22 0 29.41-13.2 29.41-29.41 0-19.39-5.15-38.63-5.52-58.29-.41-14.39-.03-28.9 1.27-43.31 5.96-13.61 12.89-26.75 21.19-39.08l1.67-2.33c4.06-5.34 12.14-.63 9.57 5.57-4.24 12.38-6.76 25.34-8.64 38.28z"
        data-original="#e0685f"
      ></path>
      <path
        fill="#ffd67b"
        d="M52.412 10.652l4.063 10.857a36.24 36.24 0 0021.24 21.24l10.857 4.063c1.732.648 1.732 3.098 0 3.746l-10.857 4.063a36.24 36.24 0 00-21.24 21.24l-4.063 10.857c-.648 1.732-3.098 1.732-3.746 0l-4.063-10.857a36.24 36.24 0 00-21.24-21.24l-10.857-4.063c-1.732-.648-1.732-3.098 0-3.746l10.857-4.063a36.24 36.24 0 0021.24-21.24l4.063-10.857c.648-1.732 3.097-1.732 3.746 0zm326.124 20.002l4.334 11.58a37.895 37.895 0 0022.208 22.208l11.58 4.334c1.732.648 1.732 3.098 0 3.746l-11.58 4.334a37.895 37.895 0 00-22.208 22.208l-4.334 11.58c-.648 1.732-3.098 1.732-3.746 0l-4.334-11.58a37.895 37.895 0 00-22.208-22.208l-11.58-4.334c-1.732-.648-1.732-3.098 0-3.746l11.58-4.334a37.895 37.895 0 0022.208-22.208l4.334-11.58c.648-1.732 3.098-1.732 3.746 0zm-199.369 63.57l-3.232 8.636a32.003 32.003 0 01-18.754 18.754l-8.636 3.232c-1.732.648-1.732 3.098 0 3.746l8.636 3.232a32.003 32.003 0 0118.754 18.754l3.232 8.636c.648 1.732 3.098 1.732 3.746 0l3.248-8.679a31.9 31.9 0 0118.695-18.695l8.679-3.248c1.732-.648 1.732-3.098 0-3.746l-8.636-3.232a32.003 32.003 0 01-18.754-18.754l-3.232-8.636c-.648-1.732-3.098-1.732-3.746 0z"
        data-original="#ffd67b"
      ></path>
    </svg>
  );
}

export default Icon;
